import { Content, Server } from '@wajeez-web/core/api-base';
import React from 'react';
import ComponentSelector from '../components';
import { useContentSelector } from '@wajeez-web/stores/content';
import { useIsMobileHook } from '@wajeez-web/components/helpers';
export interface PageWithDynamicZoneLayoutProps {
  pageData: Server.CollectionComponentDetailsOutput | undefined | null;
  context?: Content.ContentEntityOutput | null;
  areDynamicZonesHidden?: boolean;
  pageDataContextId?: string | undefined;
  hasOverflow?: boolean;
  detailsSeeMoreType?: 'categories' | 'curatedlist';
}

export function PageWithDynamicZoneLayout({
  pageData,
  children,
  context,
  areDynamicZonesHidden,
  pageDataContextId,
  hasOverflow = true,
  detailsSeeMoreType,
}: React.PropsWithChildren<PageWithDynamicZoneLayoutProps>) {
  const playerView =
    useContentSelector(
      (s) => s.contentEntity.contentWithAudioState?.playerView
    ) ?? null;

  const isMobile = useIsMobileHook();

  return (
    <div
      className={`relative ${hasOverflow && ''} h-[fit-content] sm:px-[56px] ${
        isMobile && playerView === Content.PlayingMode.MiniPlayer && 'pb-[63px]'
      }`}
    >
      {children}
      {pageData?.dynamicZone?.length ? (
        <div
          className={`flex flex-col space-y-4 sm:space-y-[15px] bg-white dark:bg-black ${
            children && 'pt-4'
          } ${areDynamicZonesHidden && 'hidden'}`}
        >
          {pageData?.dynamicZone?.map((dynamicZone, i) => (
            <ComponentSelector
              key={dynamicZone.uniqueId + '' + context?.id}
              component={dynamicZone}
              context={context}
              isLastSibling={
                pageData?.dynamicZone?.length &&
                pageData?.dynamicZone?.length - 1 === i
              }
              pageSize={10}
              pageDataId={pageData.id}
              pageDataContextId={pageDataContextId}
              seeMoreType={detailsSeeMoreType}
            />
          ))}
        </div>
      ) : null}
    </div>
  );
}

export default PageWithDynamicZoneLayout;
